export default "__VITE_ASSET__DO7jR1Ay__"